import { render, staticRenderFns } from "./QuestionPrevSet.vue?vue&type=template&id=44fd3eb1&scoped=true&"
import script from "./QuestionPrevSet.vue?vue&type=script&lang=js&"
export * from "./QuestionPrevSet.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPrevSet.vue?vue&type=style&index=0&id=44fd3eb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fd3eb1",
  null
  
)

component.options.__file = "QuestionPrevSet.vue"
export default component.exports